import {Model} from "miragejs"
import {ApplicationSerializer} from "@zhoujianhui/ultra-miragejs"

const preference = {
    models: {
        preference: Model
    },

    serializers: {
        preference: ApplicationSerializer
    },

    fixtures: {
        preferences: [
            {
                userId: 1,
                tableColumnPreferences: [
                    {
                        tableName: "UserList",
                        shownColumns: ["用户名", "手机号", "角色", "启停状态"]
                    }
                ]
            }
        ]
    },

    routes() {
        // 获取用户偏好设置
        this.get("/preferences/:userId", function (schema, request) {
            const userId = request.params.userId

            const preference = schema.preferences.where(preference => {
                return preference.userId.toString() === userId
            })

            if (preference.models.length > 0) {
                return preference.models[0]
            } else {
                return {
                    userId: userId,
                    tableColumnPreferences: []
                }
            }
        })

        // 保存用户表显示列偏好
        this.post("/preferences/:userId/table-column-preferences", function (schema, request) {
            const userId = request.params.userId;
            const tableColumnPreference = JSON.parse(request.requestBody);

            console.log(userId)
            console.log(tableColumnPreference)
        })

        // 更新用户表显示列偏好
        this.put("/preferences/:userId/table-column-preferences", function (schema, request) {
            const userId = request.params.userId;
            const tableColumnPreference = JSON.parse(request.requestBody);

            console.log(userId)
            console.log(tableColumnPreference)
        })

        // 删除用户表显示列偏好
        this.delete("/preferences/:userId/table-column-preferences/:tableName", function (schema, request) {
            const userId = request.params.userId;
            const tableName = request.params.tableName;

            console.log(userId)
            console.log(tableName)
        })
    }
}

export default preference